module.exports = __webpack_public_path__ + "img/left-arrow-bg.359781a9.svg";